
import * as React from 'react';
import { Helmet } from 'react-helmet-async';

interface IProps {
    title: string;
}

const TitleComponent: React.SFC<IProps> = ({ title }) => {
    var defaultTitle = 'Julius Biljettservice';
    return (
        <Helmet>
            <title>{title ? `${title} - ${defaultTitle}` : defaultTitle}</title>
        </Helmet>
    );
};

export default TitleComponent;


// WEBPACK FOOTER //
// ./src/helpers/DynamicTitle.tsx